import React, { useId,useState } from 'react';
import OurStorySec from './ourstorysections/OurStorySec';
import Section1 from './homesections/Section1';
import Section2 from './homesections/Section2';
import videosuiteimg from "../assets/images/video-suite.png";
//import videosuiteimg from "../assets/images/video-suite.png";
import faqsimg from "../assets/images/faqs.png";
import callusimg from "../assets/images/call-us.png";
import { Col, Container, Row } from 'react-bootstrap';
import indiciWeb from '../assets/images/help-center-image.webp'
import { Image } from 'antd';
import LazyLoad from 'react-lazyload';
import styled from "styled-components";
import { Spin } from 'antd';
import { Link } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Drawer, Form, Input, Button, DatePicker } from 'antd';
interface Ourstoryprops {
}
const handleClickVideo=()=>
{
    window.scrollTo(0, 0);
}
const handleClickFaq=()=>{
    window.scrollTo(0, 0);
}
const handleClickContactUs=()=>{
    window.scrollTo(0, 0);
}
export const HelpCenter: React.FunctionComponent<Ourstoryprops> = (props) => {
    const [drawerVisible, setDrawerVisible] = useState(false);
    const showDrawer = () => {
        setDrawerVisible(true);
    };
    const onClose = () => {
        setDrawerVisible(false);
    };
    const onFinish = async (values: any) => {
        try {
            console.log('Received values:', values);
            const formData = {
                firstname: values.firstname,
                email: values.email,
                dob: values.dob.format('YYYY-MM-DD'), 
                subject: values.subject,
                content: values.content
            };
            
            const response = await fetch('http://127.0.0.1:8000/api/submit-form', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
    
            if (response.ok) {
                console.log('Form submitted successfully');
            } else {
                console.error('Failed to submit form');
            }
        } catch (error) {
            console.error('Error submitting form:', error);
        }
    };
const TextContainer = styled.div`
text-align: center;
`;
const Title = styled.span`
  display: block;
  /* color: #fff;
  line-height: 90px; */
`;
const [loading, setLoading]=useState(true)
setTimeout(() => {
  setLoading(false); // Hide loader after 8 seconds
}, 3000);
    return (
        <React.Fragment>
    <div style={{background:'white'}} className='pb-5'>
        {/* <div className='relative-container'>
        <LazyLoadImage src={indiciWeb} className='w-100'
              placeholderSrc={indiciWeb} alt="Image Alt"/>
           
            <div className='banner-text'>
            <TextContainer>
                  <Title className="main-heading"> {`Help`}<br/>
                  {`Centre`}</Title>
                </TextContainer>
            </div>
        </div>          */}
        {loading ? <Spin spinning={loading} style={{fontSize:48}}  fullscreen /> : 
          <Section1 background={indiciWeb} title1={`Help`} 
          title2={`Centre`}  /> }
            <OurStorySec classname={''}>
                <Row className='shpbgrow pt-5 align-items-center my-padding'>
                    <Col sm={12} className='py-5'>
                        <h2 className="textHeadingTwo text-center">Looking for help? You’ve come to the right place.</h2>
                    </Col>
                </Row>
            </OurStorySec>
            <Container className='modrenHealth'>
                <Row className='shpbgrow pt-2 pb-5 align-items-center'>
                    <Col sm={12} md={6} className='text-center my-margin'>
                        <Link to="/videos"  className='faqsvideo' onClick={handleClickVideo}>
                        
                        <Image width={200} src={videosuiteimg} preview={false} />
                        <p className='pt-2 pb-2 textHeadingTwo'>Video Suite</p>
                       
                        </Link>
                    </Col>
                    <Col sm={12} md={6} className='text-center my-margin'>
                    <Link to="/faqs" className='faqsvideo' onClick={handleClickFaq}>
                        <Image width={200} src={faqsimg} preview={false} />
                        <p className='pt-2 pb-2 textHeadingTwo'>FAQs</p>
                        </Link>
                    </Col>
                    <Col sm={12} md={4} className='text-center'>
                    </Col>
                </Row >
            </Container>
            <Drawer
                title="Contact Us"
                placement="right"
                closable={false}
                onClose={onClose}
               open={drawerVisible}
                width={500} // Adjust width as needed
            >
        <Form layout="vertical" onFinish={onFinish}>
            <Form.Item
                label="First Name"
                name="firstname"
                rules={[{ required: true, message: 'Please enter your first name' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="Email"
                name="email"
                rules={[{ required: true, type: 'email', message: 'Please enter a valid email address' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="Date of Birth"
                name="dob"
                rules={[{ required: true, message: 'Please select your date of birth' }]}
            >
                <DatePicker />
            </Form.Item>
            <Form.Item
                label="Subject"
                name="subject"
                rules={[{ required: true, message: 'Please enter a valid Subject' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="Content"
                name="content"
                rules={[{ required: true, message: 'Please enter a valid Content' }]}
            >
                <Input.TextArea />
            </Form.Item>
          
            <Form.Item>
                <Button type="primary" htmlType="submit">Submit</Button>
            </Form.Item>
        </Form>
            </Drawer>
            </div>
        </React.Fragment>
    )
}
export default HelpCenter;